import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import { isModalOpenSelector, resetDeleteModal } from 'features/classCreation';
import DeleteClassModalStageRenderer from '../DeleteClassModalStageRenderer';

export default function DeleteClassModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector(isModalOpenSelector);

  const handleModalClose = useCallback(() => {
    dispatch(resetDeleteModal());
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className="p-m"
      size="large"
    >
      <DeleteClassModalStageRenderer />
    </Modal>
  );
}
